import { render } from "./PublicationShareOverlay.vue?vue&type=template&id=48f5a6e4"
import script from "./PublicationShareOverlay.vue?vue&type=script&lang=js"
export * from "./PublicationShareOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__